import _ from "lodash";
import { createSelector } from "reselect";
import { getWebsiteMetadata } from "..";

export const getAllAvailDestsSelector = createSelector(
  [getWebsiteMetadata],
  (metadata) => {
    const destinations = _.cloneDeep(_.get(metadata, "destinations", []));
    destinations.forEach(
      (dest) =>
        (dest.themes = dest.themes.map((theme) =>
          theme.split(" ").join("_").toLowerCase()
        ))
    );
    return destinations;
  }
);

const getAvailDestsByTheme = (state, { theme }) => {
  const destinations = getAllAvailDestsSelector(state);
  return destinations.filter((dest) => dest.themes.includes(theme));
};

export const getAvailDestsByThemeSelector = createSelector(
  [getAvailDestsByTheme],
  (destinations) => destinations
);
